<template>
<div class="paper" v-if="loaded">
  <modal-form modal-id="confirm-reject" animation="fadeInRight">
    <div slot="title">Reject Reason</div>
      <div slot="form">
        <v-select style="width:50%" :options="rejectedReasons" v-model="rejectedReason" required/>
        <br />
        <button class="btn-primary btn btn-xs" data-toggle="modal" data-target="#confirm-reject">No</button>
        <button class="btn-primary btn btn-xs" @click="singleReject">Yes</button>
      </div>
    </modal-form>
  <modal-form modal-id="confirm-url" animation="fadeInRight" v-if="link">
    <div slot="title">Confirm Published Url</div>
      <div slot="form">
        <strong>id: </strong>{{link.id}}<br />
        <strong>website: </strong>{{link.website}}<br />
        <strong>published url: </strong>{{publishedUrl}}<br />
        <button class="btn-primary btn btn-xs" data-toggle="modal" data-target="#confirm-url">No</button>
        <button class="btn-primary btn btn-xs" data-toggle="modal" data-target="#confirm-url" @click="()=>updateLink({target:{id:'published', value:publishedUrl}}, link)">Yes</button>
      </div>
  </modal-form>
  <modal-form modal-id="upload-invoice" animation="fadeInRight">
    <div slot="title">Invoice</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <form @submit.prevent="setInvoice">
                <label>Select Invoice File</label>
                <input type="file" name="invoiceFile" @change="onInvoiceChange" :value="[]" /><br />
                <label>or set Invoice Url</label><br /><input type="text" name="invoiceUrl" @change="onInvoiceChange" /><br />
                <br />
                  <p v-if="uploadDisabled"><span>Uploading, please wait </span> <i class="fas fa-spinner fa-spin"></i></p>
                  <button class="btn-primary btn btn-xs" type="submit" v-else>Set Invoice</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="upload-single-invoice" animation="fadeInRight">
    <div slot="title">Invoice</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <form @submit.prevent="setSingleInvoice">
                <label>Select Invoice File</label>
                <input type="file" name="invoiceFile" @change="onInvoiceChange" :value="[]" /><br />
                <label>or set Invoice Url</label><br /><input type="text" name="invoiceUrl" @change="onInvoiceChange" /><br />
                <br />
                  <p v-if="uploadDisabled"><span>Uploading, please wait </span> <i class="fas fa-spinner fa-spin"></i></p>
                  <button class="btn-primary btn btn-xs" type="submit" v-else>Set Invoice</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="single-webmaster-invoice" animation="fadeInRight">
    <div slot="title">Set webmaster invoice satus</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <v-select style="width:50%" :options="invoiceStatus" v-model="singleWebmasterInvoiceStatus">
              </v-select >
              <br />
              <!--
              Writer Invoice ID:
              <input placeholder="Writer Invoice ID" type="text" class="form-control">
              <br />-->
              <button class="btn-primary btn btn-xs" @click="setSingleWebmasterInvoiceStatus" data-toggle="modal" data-target="#single-webmaster-invoice">Update</button>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="single-writer-invoice" animation="fadeInRight">
    <div slot="title">Set writer invoice satus</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <v-select style="width:50%" :options="invoiceStatus" v-model="singleWriterInvoiceStatus">
              </v-select >
              <br />
              <!--
              Writer Invoice ID:
              <input placeholder="Writer Invoice ID" type="text" class="form-control">
              <br />-->
              <button class="btn-primary btn btn-xs" @click="setSingleWriterInvoiceStatus" data-toggle="modal" data-target="#single-writer-invoice">Update</button>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="writer-invoice" animation="fadeInRight">
    <div slot="title">Set writer invoice satus</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <v-select style="width:50%" :options="invoiceStatus" v-model="updateWriterInvoiceStatus">
              </v-select >
              <br />
              Writer Invoice ID:
              <input placeholder="Writer Invoice ID" type="text" class="form-control" v-model="writerInvoiceId">
              <br />
              <button class="btn-primary btn btn-xs" @click="setWriterInvoiceStatus" data-toggle="modal" data-target="#writer-invoice">Update</button>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="upload-single-writer-invoice" animation="fadeInRight" v-if="link">
    <div slot="title">Writer Invoice</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <form @submit.prevent="setSingleWriterInvoice">
              <label>Select Writer:</label>
               <v-select :options="writers" label="text" index="id" @change="setWriterId" style="width: 50%;" v-model="link.writer" />
               <br />
                <label>Select Invoice File</label>
                <input type="file" name="invoiceFile" @change="onInvoiceChange" :value="[]"/><br />
                <label>or set Invoice Url</label><br /><input type="text" name="invoiceUrl" @change="onInvoiceChange" v-model="link.writerInvoiceUrl" /><br />
                <br />
                  <p v-if="uploadDisabled"><span>Uploading, please wait </span> <i class="fas fa-spinner fa-spin"></i></p>
                  <button class="btn-primary btn btn-xs" type="submit" v-else>Set Invoice</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="upload-writer-invoice" animation="fadeInRight" v-if="selectedRows.length">
    <div slot="title">Writer Invoice</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <form @submit.prevent="setWriterInvoice">
              <label>Select Writer:</label>
               <v-select :options="writers" label="text" index="id" @change="setWriterId" style="width: 50%;" />
               <br />
                <label>Select Invoice File</label>
                <input type="file" name="invoiceFile" @change="onInvoiceChange" :value="[]"/><br />
                <label>or set Invoice Url</label><br /><input type="text" name="invoiceUrl" @change="onInvoiceChange" /><br />
                <br />
                  <p v-if="uploadDisabled"><span>Uploading, please wait </span> <i class="fas fa-spinner fa-spin"></i></p>
                  <button class="btn-primary btn btn-xs" type="submit" v-else>Set Invoice</button>
              </form>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="set-invoice-status" animation="fadeInRight">
    <div slot="title">Set invoice satus</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <v-select style="width:50%" :options="invoiceStatus" v-model="updateInvoiceStatus">
              </v-select >
              <br />
              Invoice ID:<br />
              <input placeholder="Invoice ID" type="text" class="form-control">
              <br />
              <button class="btn-primary btn btn-xs" @click="setInvoiceStatus" data-toggle="modal" data-target="#set-invoice-status">Update</button>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="set-order-status" animation="fadeInRight">
    <div slot="title">Set orders satus</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg">
              <label>Select Status:</label>
              <v-select style="width:50%" :options="status" v-model="updateStatus" />
              <br />
              <div v-if="updateStatus==='WM Rejected'">
              <label>Select Rejected Reason:</label>
              <v-select style="width:50%" :options="rejectedReasons" v-model="rejectedReason" required/>
              </div>
              <br />
              <button class="btn-primary btn btn-xs" @click="setOrderStatus" data-toggle="modal" data-target="#set-order-status">Update</button>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
  <modal-form modal-id="writer-status" animation="fadeInRight">
    <div slot="title">Set Writer</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-md-6">
              <label>Select Writer:</label>
               <v-select :options="writers" label="text" index="id" @change="setWriterId" />
               <br />
              <button class="btn-primary btn btn-xs" @click="setWriter" data-toggle="modal" data-target="#writer-status">Update</button>
            </div>
          </div>
        </div>
      </div>
  </modal-form>
    <div class="ibox-title">
    <h5>Orders</h5>
    </div>
    <hr />
    <div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <input placeholder="Website" type="text" v-model="filters['website']" name="" class="col-lg-8 form-control">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <input placeholder="Webmaster" type="text" v-model="filters['webmaster.name']" name="" class="col-lg-8 form-control">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <input placeholder="Webmaster Email" type="text" v-model="filters['webmaster.email']" name="" class="col-lg-8 form-control">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Tld" :options="tlds" multiple label="label" v-model="filters.tld">
            </v-select>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Categories" :options="categories" multiple label="label" v-model="filters.category">
            </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Languages"
            multiple
            :options="languages"
            label="label"
            v-model="filters['languages']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Rule Casino"
            :options="ruleCasino"
            label="label"
            v-model="filters['ruleCasino']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Writer"
            multiple
            :options="writers"
            label="text"
            index="id"
            v-model="filters['writer']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Status"
            multiple
            :options="statuses"
            label="label"
            v-model="filters['status']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Invoice Status"
            multiple
            :options="invoiceStatus"
            label="label"
            v-model="filters['invoiceStatus']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Writer Invoice Status"
            multiple
            :options="invoiceStatus"
            label="label"
            v-model="filters['writerInvoiceStatus']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <br />
          <br />
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <textarea placeholder="#ID" type="text" v-model="filters['_id']" name="" class="col-lg-8 form-control" />
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Client"
            multiple
            :options="clients"
            label="name"
            index="id"
            v-model="filters['user']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
          <v-select
            placeholder="Order Type"
            multiple
            :options="orderedLinkType"
            label="label"
            v-model="filters['orderedLinkType']"
          >
          </v-select>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 m-t-sm">
          <h4>Price (w=webmaster, c=client):</h4>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">w-cost:</div>
            <input type="number" v-model="filters['webmaster.cost']['$gte']" min="0" placeholder="from"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="number" v-model="filters['webmaster.cost']['$lte']" min="0" placeholder="to"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">c-price:</div>
            <input type="number" v-model="filters['clientPrice']['$gte']" min="0" placeholder="from"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="number" v-model="filters['clientPrice']['$lte']" min="0" placeholder="to"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Order Date:</div>
            <input type="date" v-model="filters['createdOn']['$gte']" placeholder="from"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="date" v-model="filters['createdOn']['$lte']" placeholder="to"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Published On:</div>
            <input type="date" v-model="filters['completedAt']['$gte']" min="0"  placeholder="from"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input">
            <input type="date" v-model="filters['completedAt']['$lte']" min="0"  placeholder="to"
                    class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input pull-right">
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-12 m-t-sm text-right">
          <button class="btn btn-sm btn-primary" @click="resetFilters">Reset</button>
          <button class="btn btn-sm btn-primary" @click="getlinks">Search</button>
        </div>
      </div>
    </div>
    <div class="row m-t-md">
      <div class="col-lg-12 col-md-12">
        <div class="col-lg-12 m-t-sm m-sm">
          <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#set-order-status">Set Order Status</button>
          <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#upload-invoice">Set Invoice</button>
          <button class="btn btn-sm btn-primary" data-toggle="modal" @click="invoice=''" data-target="#set-invoice-status">Set Invoice Status</button>
          <!--
          <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#writer-status">Set Writer</button>
          -->
          <button class="btn btn-sm btn-primary" data-toggle="modal" @click="invoice=''" data-target="#upload-writer-invoice">Set Writer Invoice</button>
          <button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#writer-invoice">Set Writer Invoice Status</button>
          <button class="btn btn-sm btn-primary" style="margin-left:100px" @click="exportCsv">Export CSV</button>
          <!--
            <button class="btn btn-sm btn-primary" @click="setOrderStatus">Set Order Status</button>
          -->
        </div>
      </div>
    </div>
    <hr />
    <div style="padding:0 20px">
      <div style="float: right;">
        <label>&nbsp;</label><br />
        <select @change="columnSort">
          <option value="1">asc</option>
          <option value="-1" selected>desc</option>
        </select>
      </div>
      <div style="width:200px;float: right; margin:0 10px">
        <label>Sort by:</label>
        <select @change="columnSort" style="width:100%; cursor:pointer">
          <option value="0" style="text-align:center"> -- Select Column --</option>
          <option value="_id">ID</option>
          <option value="user.username">User/Client</option>
          <option value="createdOn">Order Date</option>
          <option value="completedAt">Published On</option>
        </select>
      </div>
    </div>
    <br />
    <br />
    <div class="table-container" style="width:100%">
    <table class="table table-dark fixed-columns-table">
    <thead>
    <tr>
        <th>
            <input
              type="checkbox"
              v-model="selectAll"
            />&nbsp;&nbsp;Info</th>
        <th>Invoice</th>
        <th style="min-width: 200px">Writer</th>
        <th style="min-width: 120px">AHrefs</th>
        <th>
          w/c Price<br />
          homepage/rental Price
        </th>
        <th>Language</th>
        <th>User</th>
        <th>Target Anchor</th>
        <th>Target Domain</th>
        <th>Description</th>
        <th>Order Date</th>
        <th>Link Type</th>
        <th>WMC Price</th>
        <th>Published Url</th>
        <th>Published On</th>
        <th>Status</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="linx in links" :key="linx.id">
      <td style="background: #fff;"><input type="checkbox" :id="linx.id" :value="linx.id" v-model="selectedRows" />&nbsp;&nbsp;<strong>#id:</strong> {{linx.id}}<br />
        <strong>website:</strong> {{ linx.website }}<br/>
        <strong>webmaster:</strong> {{ linx.webmaster.name }}<br/>
          <strong>email:</strong> {{ linx.webmaster.email }}<br/>
          <strong>email 2:</strong> <input id="webmaster.email2" :value="linx.webmaster.email2"  @change="(e)=>updateLink(e, linx)">
          </td>
        <td>
          Webmaster Transaction ID:
          <input id="invoiceId" :value="linx.invoiceId" @change="(e)=>updateLink(e, linx)"><br/><br/>
          <a :href="linx.invoiceUrl.startsWith('http')?linx.invoiceUrl:`${apiEndPoint}/v2/instalinko/orders/invoice/${linx.invoiceUrl}`" :target="getTarget(linx.invoiceUrl)" v-if="linx.invoiceUrl">{{getInvoiceFileName(linx.invoiceUrl)}}</a>
          <button class="btn btn-xs btn-primary mx-2" @click="()=>popupSingleWebmasterInvoice('upload-single-invoice', linx)">Set Invoice</button><br/>
          <br />
          <p style="text-decoration: underline; color:blue; cursor:pointer" data-toggle="modal" data-target="#single-webmaster-invoice"  @click="singleWebmasterInvoiceStatus=linx.invoiceStatus; singleLink=linx.id" ><strong>Status: </strong>{{ linx.invoiceStatus }}</p>
        </td>
        <td>
          Writer Transaction ID:
          <input id="writerInvoiceId" :value="linx.writerInvoiceId" :disabled="!linx.writer" @change="(e)=>updateLink(e, linx)"><br/><br/>
          <a :href="linx.writerInvoiceUrl.startsWith('http')?linx.writerInvoiceUrl:`${apiEndPoint}/v2/instalinko/orders/invoice/${linx.writerInvoiceUrl}`" :target="getTarget(linx.writerInvoiceUrl)" v-if="linx.writerInvoiceUrl">invoice url</a>
          <button class="btn btn-xs btn-primary mx-2" @click="()=>popupSingleWriterInvoice('upload-single-writer-invoice', linx)">Set Invoice</button><br/>
          <br />
          <p style="text-decoration: underline; color:blue; cursor:pointer" data-toggle="modal" data-target="#single-writer-invoice"  @click="singleWriterInvoiceStatus=linx.writerInvoiceStatus; singleLink=linx.id" ><strong>Status: </strong>{{ linx.writerInvoiceStatus }}</p>
          <br />
          <span>Select writer</span>
          <v-select :options="writers" label="text" index="id" :value="linx.writer" @input="(e)=>updateWriter(e, linx)" /><br />
        </td>
        <td>
          <strong>Rank:</strong> {{ linx.ahrefs.rank }}<br />
          <strong>Rd:</strong> {{ linx.ahrefs.rd }}<br />
          <strong>Dr:</strong> {{ linx.ahrefs.dr }}<br />
          <strong>Keywords:</strong> {{ linx.ahrefs.keywords }}<br />
          <strong>Traffic:</strong> {{ linx.ahrefs.traffic }}
        </td>
        <td style="white-space:nowrap">{{ Number(linx.webmaster.cost).toFixed(2) }} /
          <span v-if="linx.price !== linx.clientPrice && linx.orderedLinkType==='Blog Post'">
            <strong  style="color:red">{{linx.price}}</strong> /
          </span>{{ linx.clientPrice }}
          <br />
          {{ linx.yearHomepagePrice }} /
          <span v-if="linx.price !== linx.clientPrice && linx.orderedLinkType==='Home Page'">
            <strong  style="color:red">{{linx.price}}</strong> /
          </span>{{ linx.homepageRentalClientPrice }}
        </td>
        <td>{{ linx.languages.toString() }}</td>
        <td>{{ linx.user.username }}</td>
        <td>{{ linx.targetAnchor }}</td>
        <td>{{ linx.targetWebsite }}</td>
        <td>{{ linx.topic }}</td>
        <td>{{ formatDate(linx.createdOn) }}</td>
        <td>{{ linx.orderedLinkType }}<br />{{ linx.price }}eur</td>
        <td><input @change="(e)=>updatePrice(e, linx)" v-model="linx.wmcPrice" style="max-width: 10ch;"></td>
        <td style="text-align: right;"><input id="published" :value="linx.publishedUrl" @change="setPublished"><br /><br /><button @click="()=>setConfirm(linx)" data-toggle="modal" data-target="#confirm-url">Confirm</button></td>
        <td>{{ linx.completedAt && formatDate(linx.completedAt) }}</td>
        <td style="min-width:260px">
          <span v-if="!['WM Rejected', 'WM Link Placed'].includes(linx.status)">
            <v-select :options="status" v-model="linx.status" @input="(e)=>setStatus(e, linx)"/>
            <br />
            <span v-if="linx.clientApproveStatus">Status: Price {{ linx.clientApproveStatus }}<br/><br /></span>
            <button @click="(e)=>setStatus('WM Rejected', linx)">Reject</button>
          </span>
          <span v-else>
            <strong :style="{color:setColor(linx)}">{{ linx.status }}</strong>
            <br />
            <span>{{ linx.rejectedReason }}</span>
            <span v-if="linx.status==='Content sent to approval'">{{ linx.clientApproveStatus }}</span>
          </span>
        </td>
    </tr>
    </tbody>
    </table>
  </div>
    <hr />
    <div class="pagination">
      <div style="float:left">
        <span><strong>Records: </strong>{{ totalPages }}</span>
      </div>
      <div style="text-align: center;">
        <button @click="prevPage" :disabled="page === 1">Previous</button>
        <span>&nbsp;{{ page }} / {{ Math.ceil(totalPages/perPage) }}&nbsp;</span>
        <button @click="nextPage" :disabled="page >= totalPages/perPage">Next</button>
      </div>
      <div style="float:right">
        <strong for="pageSize">Rows:&nbsp;</strong>
        <select id="pageSize" v-model="perPage" @change="changePageSize">
          <option v-for="size in pageSizes" :value="size" :key="size">{{ size }}</option>
        </select>
      </div>
    </div>
</div>
</template>

<script>
import axios from 'axios'
import Modal from '@/components/Helpers/Modal/Form'
import moment from 'moment'

const isObject = (item) => {
  return typeof item === 'object' && item !== null && !Array.isArray(item)
}

const isArray = (item) => {
  return Array.isArray(item)
}

const formFilter = (obj, format) => {
  let filter = {}
  Object.keys(obj).forEach(item => {
    if (isObject(obj[item])) {
      Object.keys(obj[item]).forEach(el => {
        if (!obj[item][el]) delete obj[item][el]
      })
      Object.keys(obj[item]).length && (filter[item] = obj[item])
    } else if (isArray(obj[item])) {
      if (obj[item].length) filter[item] = {$in: obj[item]}
    } else {
      if (obj[item]) filter[item] = format[item] ? format[item](obj[item]) : obj[item]
    }
  })
  if (filter.ruleCasino) {
    filter.ruleCasino = filter.ruleCasino === 'Yes' || false
  }

  if (filter._id) filter._id = { $in: filter._id.split(',').map((id) => id.trim()).filter(Boolean) }
  return filter
}

const field = {
  strContains: (val) => ({$regex: `.*${val}.*`, $options: 'i'})
}
const calculateWebmasterCost = function (webmasterCost) {
  switch (true) {
    case webmasterCost < 51:
      return (webmasterCost * (1 + 1.25)).toFixed(2)
    case webmasterCost < 101:
      return (webmasterCost * (1 + 0.75)).toFixed(2)
    case webmasterCost < 201:
      return (webmasterCost * (1 + 0.6)).toFixed(2)
    case webmasterCost < 501:
      return (webmasterCost * (1 + 0.4)).toFixed(2)
    default:
      return (webmasterCost * (1 + 0.3)).toFixed(2)
  }
}

// Add links Defaults
const linksAddDefaults = {
  website: '',
  tld: '',
  content: '',
  webmaster: {
    name: '',
    email: '',
    cost: 0
  },
  ahrefs: {
    rank: 0,
    dr: 0,
    rd: 0,
    keywords: 0,
    traffic: 0
  },
  clients: [],
  clientPrice: 0,
  linkType: '',
  duration: '',
  ruleCasino: '',
  category: [],
  languages: [],
  active: true,
  yearHomepagePrice: 0,
  homepageRentalClientPrice: 0
}

const defaultFilters = {
  'ahrefs.rank': {},
  'ahrefs.rd': {},
  'ahrefs.dr': {},
  'ahrefs.keywords': {},
  'ahrefs.traffic': {},
  'webmaster.cost': {},
  'clientPrice': {},
  'createdOn': {},
  'completedAt': {}
}

export default {
  data () {
    return {
      writerInvoiceId: '',
      writerInvoiceUrl: '',
      apiEndPoint: process.env.API,
      singleWriterInvoiceStatus: '',
      singleWebmasterInvoiceStatus: '',
      loaded: false,
      writerInvoiceStatus: null,
      singleLink: null,
      isModalOpen: false,
      link: null,
      updateStatus: null,
      updateInvoiceStatus: '',
      updateWriterInvoiceStatus: '',
      selectedRows: [],
      selectAll: false,
      sort: {field: 'createdOn', direction: '-1'},
      active: ['Yes', 'No'],
      ruleCasino: ['Yes', 'No'],
      tlds: [],
      languages: [],
      categories: [],
      rejectedReason: null,
      rejectedReasons: [
        'Higher Price',
        'Casino Not Accepted',
        'Does Not Accept Guest Posts',
        'Ordered Twice'
      ],
      orderedLinkType: [
        'Blog Post',
        'Home Page'
      ],
      invoiceStatus: [
        'Pending Invoice',
        'Pending Payment',
        'Paid',
        'Cancelled'
      ],
      status: [
        'WM Contact or Pending',
        'WM Contacted',
        'Content in progress',
        'Content sent for approval',
        'Content sent for publishing'
        // 'WM Rejected',
        // 'WM Link Placed'
      ],
      statuses: [
        'WM Contact or Pending',
        'WM Contacted',
        'Content in progress',
        'Content sent for approval',
        'Content sent for publishing',
        'WM Rejected',
        'WM Link Placed'
      ],
      filters: {
        'ahrefs.rank': {},
        'ahrefs.rd': {},
        'ahrefs.dr': {},
        'ahrefs.keywords': {},
        'ahrefs.traffic': {},
        'webmaster.cost': {},
        'clientPrice': {},
        'createdOn': {},
        'completedAt': {}
      },
      format: {
        'webmaster.name': field.strContains,
        'webmaster.email': field.strContains,
        'website': field.strContains
      },
      writers: [],
      publishedUrl: null,
      uploadDisabled: false,
      file: null,
      invoiceUrl: '',
      links: [],
      addlinks: {...linksAddDefaults},
      page: 1,
      perPage: 10,
      totalPages: 0,
      pageSizes: [10, 25, 50]
    }
  },
  watch: {
    selectAll (newValue) {
      if (newValue) {
        this.selectedRows = this.links.map(obj => obj.id)
      } else {
        this.selectedRows = []
      }
    }
  },
  async beforeMount () {
    const [tld, categories, languages, writers, clients] = await Promise.all([
      axios.get(`/v2/instalinko/inventory/tlds`),
      axios.get(`/v2/instalinko/inventory/categories`),
      axios.get(`/v2/instalinko/inventory/languages`),
      axios.get(`/v2/instalinko/writers-list`),
      axios.get(`/v2/instalinko/users`, {params: {roles: 'client'}})
    ])
    this.writers = writers.data.map(obj => ({
      id: obj.id,
      text: obj.name + ' - ' + obj.price + 'eur'
    }))
    this.clients = clients.data
    this.tlds = tld.data
    this.categories = categories.data
    this.languages = languages.data
    this.getlinks()
  },
  components: {
    modalForm: Modal
  },
  methods: {
    getTarget (text = '') {
      return text.endsWith('pdf') || text.startsWith('http') ? '_blank' : ''
    },
    getInvoiceFileName (file) {
      const uuid = file.split('.')[0]
      if (uuid.length === 36) {
        file = file.substring(37)
      }
      return file.includes('.') ? file : 'invoice.' + file
    },
    popupSingleWebmasterInvoice (id, link) {
      this.link = link
      this.$nextTick(() => $('#' + id).modal('show'))
    },
    popupSingleWriterInvoice (id, link) {
      this.link = link
      this.$nextTick(() => $('#' + id).modal('show'))
    },
    async exportCsv () {
      const { data } = await axios.get(`/v2/instalinko/orders/export`, { params: {filter: formFilter(this.filters, this.format)}, responseType: 'blob' })
      const url = URL.createObjectURL(new Blob([data]))
      const a = document.createElement('a')
      a.href = url
      a.download = 'orders-export.csv'
      a.click()
      URL.revokeObjectURL(url)
    },
    resetFilters () {
      this.filters = JSON.parse(JSON.stringify(defaultFilters))
      setTimeout(this.getlinks, 10)
    },
    setColor (link) {
      switch (link.status) {
        case 'WM Rejected':
          return '#c23b22'
        case 'WM Link Placed':
          return '#03c03c'
        default:
          return '#676a6c'
      }
    },
    formatDate (date) {
      return moment(date).format('DD.MM.YYYY hh:mm:ss')
    },
    async setSingleWriterInvoice () {
      this.uploadDisabled = true
      const formData = new FormData()
      formData.append('myFile', this.file)
      formData.append('writer', this.writer)
      formData.append('id', this.link.id)
      formData.append('writerInvoiceUrl', this.invoiceUrl)

      try {
        await axios.post('/v2/instalinko/orders/writer-invoice', formData)
        this.$toastr.success('Invoice updated successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to update invoice')
      }
      this.invoiceUrl = ''
      this.getlinks()
      this.uploadDisabled = false
      this.file = null
    },
    async setSingleWriterInvoiceStatus () {
      try {
        await axios.patch(`/v2/instalinko/orders/${this.singleLink}`, {writerInvoiceStatus: this.singleWriterInvoiceStatus})
        this.$toastr.success('Invoices updated successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to update invoice')
      }
      this.singleWriterInvoiceStatus = ''
      this.singleLink = ''
      this.getlinks()
    },
    async setSingleWebmasterInvoiceStatus () {
      try {
        await axios.patch(`/v2/instalinko/orders/${this.singleLink}`, {invoiceStatus: this.singleWebmasterInvoiceStatus})
        this.$toastr.success('Invoices updated successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to update invoice')
      }
      this.singleWebmasterInvoiceStatus = ''
      this.singleLink = ''
      this.getlinks()
    },
    async setWriterInvoiceStatus () {
      console.log(this.selectedRows)
      console.log(this.updateWriterInvoiceStatus)
      let data = {}
      if (this.writerInvoiceId) data.writerInvoiceId = this.writerInvoiceId
      if (this.updateWriterInvoiceStatus) data.writerInvoiceStatus = this.updateWriterInvoiceStatus
      await axios.patch(`/v2/instalinko/orders`, {filter: {_id: {$in: this.selectedRows}}, data})
      this.$toastr.success('Invoices updated successfully', 'Brilliant stuff lad')
      this.getlinks()
      this.writerInvoiceStatus = null
      this.writerInvoiceUrl = null
    },
    setPublished (e) {
      this.publishedUrl = e.target.value
    },
    setConfirm (link) {
      this.link = link
    },
    setWriterId (val) {
      this.writer = val
    },
    async setWriterInvoice () {
      this.uploadDisabled = true
      const formData = new FormData()
      if (this.file) formData.append('myFile', this.file)
      if (this.writer) formData.append('writer', this.writer)
      formData.append('id', this.invoice || JSON.stringify({$in: this.selectedRows}))
      if (this.invoiceUrl) formData.append('writerInvoiceUrl', this.invoiceUrl)

      try {
        if (this.file || this.invoiceUrl) {
          await axios.post('/v2/instalinko/orders/writer-invoice', formData)
        } else if (this.writer) {
          await axios.patch('/v2/instalinko/links', {filter: {$in: this.selectedRows}, data: {writer: this.writer}})
        }
        this.$toastr.success('Invoice updated successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to update invoice')
      }
      this.invoice = ''
      this.invoiceUrl = ''
      this.writer = ''
      this.getlinks()
      this.uploadDisabled = false
      this.file = null
    },
    async setSingleInvoice (multi) {
      this.uploadDisabled = true
      console.log('import inventory')
      console.log(this.file)
      const formData = new FormData()
      formData.append('myFile', this.file)
      formData.append('id', this.link.id)
      formData.append('invoiceUrl', this.invoiceUrl)

      try {
        await axios.post('/v2/instalinko/orders/invoice', formData)
        this.$toastr.success('Invoice updated successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to update invoice')
      }
      this.uploadDisabled = false
      this.invoiceUrl = ''
      this.link = ''
      this.file = null
      this.getlinks()
    },
    async setInvoice (multi) {
      this.uploadDisabled = true
      console.log('import inventory')
      console.log(this.file)
      const formData = new FormData()
      formData.append('myFile', this.file)
      formData.append('id', this.invoice || JSON.stringify({$in: this.selectedRows}))
      formData.append('invoiceUrl', this.invoiceUrl)

      try {
        await axios.post('/v2/instalinko/orders/invoice', formData)
        this.$toastr.success('Invoice updated successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to update invoice')
      }
      this.uploadDisabled = false
      this.file = null
      this.invoiceUrl = ''
    },
    async updatePrice (e, link) {
      if (link.webmaster.cost < e.target.value) {
        switch (link.orderedLinkType) {
          case 'Blog Post':
            await axios.patch(`/v2/instalinko/inventory/${link.inventory}`, { 'webmaster.cost': e.target.value, clientPrice: calculateWebmasterCost(e.target.value) })
            await axios.patch(`/v2/instalinko/orders/${link.id}`, { wmcPrice: e.target.value })
            this.$toastr.success('Blog Post Price changed successfully', 'Brilliant stuff lad')
            break
          case 'Home Page':
            await axios.patch(`/v2/instalinko/inventory/${link.inventory}`, { 'yearHomepagePrice': e.target.value, homepageRentalClientPrice: calculateWebmasterCost(e.target.value) })
            await axios.patch(`/v2/instalinko/orders/${link.id}`, { wmcPrice: e.target.value })
            this.$toastr.success('Home Page Price changed successfully', 'Brilliant stuff lad')
            break
        }
      } else {
        await axios.patch(`/v2/instalinko/orders/${link.id}`, { wmcPrice: e.target.value })
        this.$toastr.success('Price changed successfully', 'Brilliant stuff lad')
      }
    },
    async updateWriter (val, link) {
      await axios.patch(`/v2/instalinko/orders/${link.id}`, {writer: val})
      this.getlinks()
    },
    async updateLink (e, link) {
      if (e.target.id === 'published') {
        await Promise.all([
          axios.patch(`/v2/instalinko/orders/${link.id}`, {publishedUrl: e.target.value}),
          this.setStatus('WM Link Placed', link)
        ])
      } else if (e.target.id === 'webmaster.email2') {
        await Promise.all([
          axios.patch(`/v2/instalinko/orders/${link.id}`, {[e.target.id]: e.target.value}),
          axios.patch(`/v2/instalinko/inventory/${link.inventory}`, {[e.target.id]: e.target.value})
        ])
      } else if (e.target.id === 'invoiceId') {
        const data = {[e.target.id]: e.target.value}
        data.invoiceStatus = e.target.value ? 'Paid' : link.invoiceStatus
        await axios.patch(`/v2/instalinko/orders/${link.id}`, data)
      } else if (e.target.id === 'writerInvoiceId') {
        const data = {[e.target.id]: e.target.value}
        data.writerInvoiceStatus = e.target.value ? 'Paid' : link.writerInvoiceStatus
        await axios.patch(`/v2/instalinko/orders/${link.id}`, data)
      } else {
        await axios.patch(`/v2/instalinko/orders/${link.id}`, {[e.target.id]: e.target.value})
      }
      this.getlinks()
    },
    async singleReject () {
      if (this.rejectedReason) {
        await axios.post(`/v2/instalinko/links/update`, {filter: {_id: this.singleLink}, status: 'WM Rejected', rejectedReason: this.rejectedReason})
        this.getlinks()
        $('#confirm-reject').modal('hide')
      } else {
        alert('Please select reject reason')
      }
    },
    async setStatus (val, link) {
      if (val === 'WM Rejected') {
        this.singleLink = link.id
        $('#confirm-reject').modal('show')
      } else if (val === 'Content sent for approval') {
        const { data } = await axios.get(`/v2/instalinko/links/${link.id}`)
        if (!data.wmcClientPrice || data.wmcClientPrice < data.price) {
          link.status = 'Content in progress'
          alert('WMC Price should be greater than Client Price')
        } else {
          await axios.post(`/v2/instalinko/links/update`, {filter: {_id: link.id}, status: val})
        }
      } else if (val) {
        this.links = this.links.map(obj => {
          if (obj.id === link.id) {
            axios.post(`/v2/instalinko/links/update`, {filter: {_id: link.id}, status: val})
            return {...obj, status: val, publishedUrl: this.publishedUrl || link.publishedUrl}
          }
          return obj
        })
      }
    },
    async setWriter () {
      console.log(this.selectedRows)
      await axios.patch(`/v2/instalinko/orders`, {filter: {_id: {$in: this.selectedRows}}, data: {writer: this.writer}})
      this.$toastr.success('Writers added successfully', 'Brilliant stuff lad')
    },
    async setInvoiceStatus () {
      console.log(this.selectedRows)
      await axios.patch(`/v2/instalinko/orders`, {filter: {_id: {$in: this.selectedRows}}, data: {invoiceStatus: this.updateInvoiceStatus}})
      this.$toastr.success('Invoices updated successfully', 'Brilliant stuff lad')
    },
    async setOrderStatus () {
      let rejectedReason = ''
      if (this.updateStatus === 'WM Rejected') {
        rejectedReason = this.rejectedReason
      }
      await axios.post(`/v2/instalinko/links/update`, {filter: {_id: {$in: this.selectedRows}}, status: this.updateStatus, rejectedReason})
      this.getlinks()
      this.$toastr.success('Orders updated successfully', 'Brilliant stuff lad')
    },
    selectRow (e) {
      console.log(e.target.checked)
    },
    columnSort (e) {
      if (Math.abs(e.target.value) === 1) {
        this.sort.direction = e.target.value
      } else {
        this.sort.field = e.target.value
      }
      this.getlinks()
    },
    onInvoiceChange (e) {
      console.log(e.target.id)
      if (e.target.name === 'invoiceUrl') {
        console.log(e.target.value)
        this.invoiceUrl = e.target.value
      } else if (e.target.name === 'invoiceFile') {
        this.file = e.target.files[0]
      }
    },
    async exportlinks () {
      const {data} = await axios.get(`/v2/instalinko/links/download`, { params: {filter: formFilter(this.filters, this.format)}, responseType: 'blob' })
      const url = URL.createObjectURL(new Blob([data]))
      const a = document.createElement('a')
      a.href = url
      a.download = 'links-export.csv'
      a.click()
      URL.revokeObjectURL(url)
    },
    async savelinks () {
      const addlinks = {...this.addlinks}
      try {
        console.log(addlinks)
        const res = await axios.post('/v2/instalinko/links', addlinks)
        console.log(res)
        this.links = [...this.links, addlinks]
        this.$toastr.success('links added successfully', 'Brilliant stuff lad')
      } catch (err) {
        this.$toastr.error(err, 'Unable to create links')
      }
    },
    changePageSize () {
      this.page = 1 // reset the page to the first page when changing the page size
      this.getlinks()
    },
    async getlinks () {
      try {
        const res = await axios.get(`/v2/instalinko/links`, {
          params: {
            filter: formFilter(this.filters, this.format),
            options: {
              page: this.page,
              perPage: this.perPage,
              sort: this.sort.field !== '0' ? {
                [this.sort.field]: Number(this.sort.direction)
              } : {}
            }
          }
        })
        this.links = res.data
        this.totalPages = Number(res.headers['x-total-records'] || 2)
      } catch (err) {
        console.log(err)
        this.$toastr.error(err, 'Unable to get links')
      }
      this.loaded = true
    },
    nextPage () {
      if (this.page < this.totalPages) {
        this.page++
        this.getlinks()
      }
    },
    prevPage () {
      if (this.page > 1) {
        this.page--
        this.getlinks()
      }
    }
  }
}
</script>
<style scoped>
.paper{
  background: #fff;
  margin-top: 10px;
}
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination>div {
  flex: 1;
  padding: 10px;
  display: flex; /* Enable vertical alignment */
  align-items: center;
}

.pagination>div:nth-child(2) {
  justify-content: center;
}

.pagination>div:nth-child(3) {
  justify-content: flex-end;
}
.table-container {
  border-left: 1px solid #eee;
  overflow-x: auto;
}

.fixed-columns-table th,
.fixed-columns-table td {
  border: 1px solid #ddd;
  padding: 8px;
}

.fixed-columns-table th:first-child,
.fixed-columns-table td:first-child {
  z-index: 99;
  position: sticky;
  left: 0;
  background-color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/Orders.vue